<template>
  <div class="abs top">
    <button class="abs ruleBtn" @click="showRule"></button>
    <div v-if="isLogin" class="abs userInfo"><img src="@images/icon_user.png" alt="">{{ userName }}  <button class="logout" @click="logout"></button></div>
    <button v-else class="abs loginBtn" @click="login"></button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { showPop } from '@/utils/common.js';

export default {
  computed: {
    ...mapState(['isLogin']),
    ...mapGetters(['userName']),
  },
  methods: {
    showPop,
    showRule(){
      this.showPop('Rule');
    },
    login(){
      $.islogin(true)
    },
    logout(){
      logout();
    }
  }
}
</script>

<style scoped>
.top{ top: 0; width: 100%;}
.ruleBtn{ top: 19px; left: 25px; width: 122px; height: 56px; background: url(@images/ruleBtn.png) no-repeat 0 0;}
.userInfo{ top: 20px; right: 30px; height: 56px; display: flex; align-items: center; font-weight: bold; font-size: 32px; color: #7d39d7;;}
.userInfo img{ margin-right: 10px;}
.loginBtn{ top: 20px; right: 30px; width: 202px; height: 55px; background: url(@images/loginBtn.png) no-repeat 0 0;}
.logout{ margin-left: 15px; width: 85px; height: 40px; background: url(@images/logout.png) no-repeat 0 0;}
</style>